import { ParameterMapping, TaskDetail } from '@/types/sdk';
import mitt from 'mitt';

export const APPLY_PARAMS_EVENT = 'applyParams';
export const UPDATE_PREVIEW_COUNT_EVENT = 'updatePreviewCount';
export const UPDATE_PREVIEW_RATIO_EVENT = 'updatePreviewRatio';
export const UPDATE_CREDITS_USAGE_EVENT = 'updateCreditsUsage';
export const ADD_NEW_HISTORY_ITEM_EVENT = 'addNewHistoryItem';
export const ADD_NEW_HISTORY_ITEM_FAILED_EVENT = 'addNewHistoryItemFailed';
export const UPDATE_SHORTCUTS_EVENT = 'updateShortcuts';
export const FLYING_ANIMATION_EVENT = 'flyingAnimation';
export const UPDATE_CANVAS_IMAGE_STATE_EVENT = 'updateCanvasImageState';
export const OPEN_API_MODAL_EVENT = 'openApiModalEvent';
export const WORKFLOW_DETAIL_MODAL_CLOSE_EVENT = 'workflowDetailModalClose';

type ApplyParamsEvent = {
  [APPLY_PARAMS_EVENT]: ParameterMapping[];
  [UPDATE_PREVIEW_COUNT_EVENT]: number;
  [UPDATE_PREVIEW_RATIO_EVENT]: string;
  [UPDATE_CREDITS_USAGE_EVENT]: number;
  [ADD_NEW_HISTORY_ITEM_EVENT]: TaskDetail;
  [ADD_NEW_HISTORY_ITEM_FAILED_EVENT]: { requestId: string };
  [UPDATE_SHORTCUTS_EVENT]: TaskDetail;
  [FLYING_ANIMATION_EVENT]: void;
  [UPDATE_CANVAS_IMAGE_STATE_EVENT]: boolean;
  [OPEN_API_MODAL_EVENT]: boolean;
  [WORKFLOW_DETAIL_MODAL_CLOSE_EVENT]: void;
};

export const globalMitt = mitt<ApplyParamsEvent>();
